import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import React from "react";
import { createPopper } from "@popperjs/core";
import { debounce } from "@/global/utils/utils";

const debouncedClose = debounce();

export function useMapViewerTooltip(viewer: any) {
  const { sm: smDown } = useCssMediaQuery("down");
  const tooltipRef = React.useRef<HTMLDivElement | null>(null);
  const [isMouseOverTooltip, setIsMouseOverTooltip] = React.useState(false);
  const [isMouseOverNode, setIsMouseOverNode] = React.useState<any>(null);

  // active node for all devices
  const [tooltipNode, setTooltipNode] = React.useState<any>(null);
  // tooltip on desktop and tablet
  const [isTooltipOpen, setIsTooltipOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!smDown && viewer) {
      viewer.subscribe("enter", function (obj: any) {
        var node = obj.nodes[0];
        if (node && node.state == "available") {
          setTooltipNode(node);
          setIsMouseOverNode(true);
        }
      });

      viewer.subscribe("leave", () => {
        setIsMouseOverNode(false);
      });
    }
  }, [viewer, smDown]);

  // creating tooltip
  React.useEffect(() => {
    if (!smDown && tooltipRef.current) {
      if (tooltipNode) {
        createPopper(tooltipNode, tooltipRef.current as any, {
          placement: "top",
          modifiers: [],
        });
        setIsTooltipOpen(true);
      }
    }
  }, [tooltipRef, tooltipNode, smDown]);

  React.useEffect(() => {
    // manual debouncing
    if (!smDown) {
      const timer = setTimeout(() => {
        if (isMouseOverNode || isMouseOverTooltip) return;
        setIsTooltipOpen(false);
        setTooltipNode(null);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isMouseOverTooltip, isMouseOverNode, tooltipNode, smDown]);

  return {
    tooltipRef,
    setIsMouseOverTooltip,
    isMouseOverTooltip,
    setTooltipNode,
    tooltipNode,
    setIsTooltipOpen,
    isTooltipOpen,
  };
}
